<div class="d-flex justify-content-between align-items-end pb-3 autocomlete-header">
  <h2 mat-dialog-title class="text-black fw-medium p-0 mb-0">{{ 'eventForm.formFields.bio' | translate }}</h2>
  <button class="border-0 bg-transparent delete-btn" (click)="onClose()">
    <i class="das das-corss fs-12 close-btn"></i>
  </button>
</div>

<div mat-dialog-content class="dialog-scrollable-content">
  <div class="bio-content" [innerHTML]="data.bio"></div>
</div>
